import { render } from "./ChildCommentList.vue?vue&type=template&id=cf9090ce&scoped=true&ts=true"
import script from "./ChildCommentList.vue?vue&type=script&lang=ts"
export * from "./ChildCommentList.vue?vue&type=script&lang=ts"

import "./ChildCommentList.vue?vue&type=style&index=0&id=cf9090ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf9090ce"]])

export default __exports__